import { BackgroundController } from "@quest/murka-games-behavior-panther/dist";
import { gameConstants, spineConstants } from "../Constants/gameConstants";
import { Container, dispatcher, ingenuity,  SpineBase } from "@quest/base-core";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { IEvent } from "@quest/adapter-interface";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
export class BackgroundControllerGame extends BackgroundController {
  private roomDesktopBg: SpineBase;
  private roomPortraitBg: SpineBase;
  private investigationBgSpineContainer:Container;

  protected initializeElements(): void {
    super.initializeElements();
    this.investigationBgSpineContainer = this.view.getContainerByID('investigationBgSpineContainer');
    this.basegameIldeSpine = this.view.getSpineById("Basegame_Desktop");

  }

  protected subscribeEvents(): void {
    super.subscribeEvents();
        dispatcher.on(eventDispatchers.HIDE_INVESTIGATION_BACKGROUND, this.hideInvestigationBg, this);
        dispatcher.on(eventDispatchers.CHECK_RESIZE,this.handleBonusSpineVisibility,this)

  }
   /**
   * overrided to show bonus background with fade effect
   */
  protected hideInvestigationBg(): void {
    this.investigationBgSpineContainer.visible = false;
  }

   /**
   * overrided to add bonus background case
   */
  protected changeBackground(evt: IEvent): void {
    if (evt.data === gameConstants.INVESTIGATION_BG_SHOW) {
      this.hideAllBg();
      this.roomDesktopBg = this.view.getSpineById("roomDesktopBg");
      !ingenuity.deviceEnv.isDesktop && (this.roomPortraitBg = this.view.getSpineById("roomPortraitBg"));
      !ingenuity.deviceEnv.isDesktop && this.handleBonusSpineVisibility();
      this.showHoldAndRespinBg();
    } else {
      super.changeBackground(evt);
    }
  }
   /**
   * Handle bonus spine visibility
   */
  private handleBonusSpineVisibility(): void {
    if(!this.roomDesktopBg) return;
    if (ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.LANDSCAPE) {
      if(this.roomDesktopBg) { this.roomDesktopBg.alpha = 1;}
      if(this.roomPortraitBg){ this.roomPortraitBg.alpha = 0;}
    } else {
     if(this.roomDesktopBg) {this.roomDesktopBg.alpha = 0;}
      if(this.roomPortraitBg){this.roomPortraitBg.alpha = 1;}
    }
  }


   /**
   * overrided to show bonus background with fade effect
   */
  protected showHoldAndRespinBg(): void {
    this.investigationBgSpineContainer.visible = true;
    this.playBonusgameIdleSpine();
  }
   /**
   * overrided to play bonus background spine
   */
  private playBonusgameIdleSpine() {
    this.roomDesktopBg.visible = true;
    this.roomDesktopBg.playAnim('investigation_room_bg', true);
    if (!ingenuity.deviceEnv.isDesktop) {
      this.playBonusgameIdleSpinePortrait();
    }
  }

  /**
   * Add to play bonus portrait spine
   */
  private playBonusgameIdleSpinePortrait() {
    this.roomPortraitBg.visible = true;
    this.roomPortraitBg.playAnim('investigation_room_bg_port', true);
  }
 
  protected playBasegameIdlePortraitSpine(): void {
    this.basegameBgSpineContainer.visible = true;
        this.basegameIldePortraitSpine && this.basegameIldePortraitSpine.setPause(false);
        this.basegameIldePortraitSpine.playAnim(spineConstants.BASEGAME_IDLE_PORT, true);
  }

  //
  public playFreegameIdleSpine() {
    super.playFreegameIdleSpine();
    this.freegameBgSpineContainer.visible = true;
  }

  // Method to play free game idle portrait spine animation
  protected playFreegameIdlePortraitSpine(): void {
    let _a, _b;
    (_a = this.freegameBgPortraitrSpine) === null || _a === void 0 ? void 0 : _a.playAnim(spineConstants.FREEGAME_IDLE_SPINE_PORTRAIT, true);
    (_b = this.freegameBgPortraitrSpine) === null || _b === void 0 ? void 0 : _b.setPause(false);
  }
}
